var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDossierCreatif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 160 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st1{fill:#808080;}\n\t.st2{fill:#404040;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.2,95.1l55.4,9.7c1.8,0.3,3.4-0.9,3.4-2.5V38.5c0-1.2-1-2.3-2.3-2.5l-55.4-9.7c-1.8-0.3-3.4,0.9-3.4,2.5 v63.8C72.8,93.8,73.8,94.9,75.2,95.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,100.4l55.4,9.7c1.8,0.3,3.4-0.9,3.4-2.5V43.8c0-1.2-1-2.3-2.3-2.5l-55.4-9.7c-1.8-0.3-3.4,0.9-3.4,2.5 v63.8C64.2,99.1,65.2,100.1,66.5,100.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,106.4l55.4,9.7c1.8,0.3,3.4-0.9,3.4-2.5V49.8c0-1.2-1-2.3-2.3-2.5l-55.4-9.7c-1.8-0.3-3.4,0.9-3.4,2.5 v63.8C55.2,105.1,56.2,106.1,57.6,106.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,112.4l55.4,9.7c1.8,0.3,3.4-0.9,3.4-2.5V55.8c0-1.2-1-2.3-2.3-2.5l-55.4-9.7c-1.8-0.3-3.4,0.9-3.4,2.5 v63.8C46,111.1,47,112.1,48.3,112.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,117.6l55.4,9.7c1.8,0.3,3.4-0.9,3.4-2.5V61c0-1.2-1-2.3-2.3-2.5l-55.4-9.7c-1.8-0.3-3.4,0.9-3.4,2.5v63.8 C36.8,116.3,37.8,117.4,39.1,117.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,123.3l55.4,9.7c1.8,0.3,3.4-0.9,3.4-2.5V66.7c0-1.2-1-2.3-2.3-2.5l-55.4-9.7c-1.8-0.3-3.4,0.9-3.4,2.5v63.8 C26.7,122,27.7,123.1,29,123.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,107.2c0,0,5-3.3,5-10.7c0.1-7.4,0-12.4,0-12.4s0.1-3.5-3.4-4.1C65.6,79.4,57,78,57,78s-6.9-1.6-12,3.3 C39.9,86.1,67.5,107.2,67.5,107.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.7,81.7c0,0-5,3.3-5,10.7c-0.1,7.4,0,12.4,0,12.4s-0.1,3.5,3.4,4.1c3.5,0.6,12.1,2.1,12.1,2.1 s6.9,1.6,12-3.3C72.2,102.8,44.7,81.7,44.7,81.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1,81.4c0,0,2.8-2.5,8-2.5s8,2.1,8,2.1s6.8,4.1,9,10.3c1.9,5.3,0.8,10,0.8,10s-1.1,4.4-3.9,6.4c-2.7,2-5.8,2.2-5.8,2.2 s-5.5,1.2-11.7-3s-7.9-11-7.9-11s-1.6-5,0.1-9.3C43.6,82.4,45.1,81.4,45.1,81.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.8,89.3l0.1,9.5c0,0,0.3,2.2,2.2,1.6c1.9-0.6,8.7-3.6,8.7-3.6s0.6-0.3,0.6-1.2c0-0.9-0.5-1.3-0.5-1.3 L54,87.6c0,0-0.9-0.5-1.7,0.1C51.6,88.3,51.8,89.3,51.8,89.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDossierCreatif);
export default __webpack_public_path__ + "static/media/dossier_creatif.447e33fd98392a71d9753df7e0fa281c.svg";
export { ForwardRef as ReactComponent };